export default {
  // id: null,
  codigo: '',
  descricao: '',
  valor: ''
}